"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settingsRoutesArray = exports.settingsNavItems = void 0;
var _react = _interopRequireDefault(require("react"));
var _load = _interopRequireDefault(require("../hocs/load"));
var _config = _interopRequireDefault(require("../config"));
var _path = _interopRequireDefault(require("../helpers/path"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ProfileAndSettingsContainer = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../layouts/ProfileAndSecurityLayout/ProfileAndSecurityLayout'));
  });
});
var KYCSettingsContainer = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../components/KYCSettings'));
  });
});
var ApiKeysLayout = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../layouts/ApikeysLayout/ApiKeysLayout'));
  });
});
var UserContactsLayout = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../layouts/UserContactsLayout/UserContactsLayout'));
  });
});
var AffiliateContainer = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../layouts/AffiliateLayout/AffiliateLayoutContainer'));
  });
});
var LoyaltyToken = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../layouts/SettingsLayout/ChildrenLayouts/LoyaltyTokenLayout'));
  });
});
var TradeSettingsContainer = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../components/Settings/TradeSettings'));
  });
});
var DemoSettingsContainer = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../components/Settings/DemoSettings/DemoSettingsContainer'));
  });
});
var TradeReportLayout = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../layouts/TradeReportLayout/TradeReportLayout'));
  });
});
var IBASettingsContainer = (0, _load["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../components/Settings/InterestBearingAccounts/'));
  });
});

// this.t('Profile & Security')
// this.t('Verification Level')
// this.t('API Keys')
// this.t('Trade Reports')
// this.t('User Contacts')
// this.t('Affiliate Program')
// this.t('Loyalty Token')
// this.t('Demo Settings')
// this.t('Trade Settings')
// this.t('Yield Settings')
var _config$Settings = _config["default"].Settings,
  profile = _config$Settings.profile,
  apiKeys = _config$Settings.apiKeys,
  tradeReports = _config$Settings.tradeReports,
  userContacts = _config$Settings.userContacts,
  affiliate = _config$Settings.affiliate,
  loyaltyToken = _config$Settings.loyaltyToken,
  kyc = _config$Settings.kyc,
  tradeSettings = _config$Settings.tradeSettings,
  interestBearingAccountSettings = _config$Settings.interestBearingAccountSettings,
  demoMode = _config$Settings.demoMode;
var settingsNavItems = exports.settingsNavItems = [{
  text: 'Profile & Security',
  path: '/settings/profile',
  show: profile,
  icon: 'security'
}, {
  text: 'Trade Settings',
  path: '/settings/trade',
  show: tradeSettings,
  icon: 'tasks'
}, {
  text: 'Yield Settings',
  path: '/settings/iba',
  show: interestBearingAccountSettings,
  icon: 'sell'
}, {
  text: 'Verification Level',
  path: '/settings/verification',
  show: kyc,
  icon: 'tasks'
}, {
  text: 'API Keys',
  path: '/settings/api-keys',
  show: apiKeys,
  icon: 'key'
}, {
  text: 'Trade Reports',
  path: '/settings/trade-reports',
  show: tradeReports,
  icon: 'reports'
}, {
  text: 'User Contacts',
  path: '/settings/contacts',
  show: userContacts,
  icon: 'contacts'
}, {
  text: 'Affiliate Program',
  path: '/settings/affiliate',
  show: affiliate,
  icon: 'friends'
}, {
  text: 'Loyalty Token',
  path: '/settings/loyalty-token',
  show: loyaltyToken,
  icon: 'heart'
}, {
  text: 'Demo Settings',
  path: '/settings/demo-settings',
  show: demoMode,
  icon: 'paint'
}];
var settingsRoutesArray = exports.settingsRoutesArray = [{
  path: '/settings/profile',
  render: function render() {
    return /*#__PURE__*/_react["default"].createElement(ProfileAndSettingsContainer, null);
  }
}, {
  path: '/settings/trade',
  show: tradeSettings,
  render: function render() {
    return /*#__PURE__*/_react["default"].createElement(TradeSettingsContainer, null);
  }
}, {
  path: '/settings/iba',
  show: interestBearingAccountSettings,
  render: function render() {
    return /*#__PURE__*/_react["default"].createElement(IBASettingsContainer, null);
  }
}, {
  path: '/settings/verification',
  render: function render() {
    return /*#__PURE__*/_react["default"].createElement(KYCSettingsContainer, null);
  }
}, {
  path: '/settings/api-keys',
  show: apiKeys,
  render: function render() {
    return /*#__PURE__*/_react["default"].createElement(ApiKeysLayout, null);
  }
}, {
  path: '/settings/trade-reports',
  show: tradeReports,
  render: function render() {
    return /*#__PURE__*/_react["default"].createElement(TradeReportLayout, null);
  }
}, {
  path: '/settings/contacts',
  show: userContacts,
  render: function render() {
    return /*#__PURE__*/_react["default"].createElement(UserContactsLayout, null);
  }
}, {
  path: '/settings/affiliate',
  show: affiliate,
  render: function render() {
    return /*#__PURE__*/_react["default"].createElement(AffiliateContainer, {
      route: "".concat(window.location.origin).concat((0, _path["default"])(''), "/signup?aff=")
    });
  }
}, {
  path: '/settings/loyalty-token',
  show: loyaltyToken,
  render: function render() {
    return /*#__PURE__*/_react["default"].createElement(LoyaltyToken, null);
  }
}, {
  path: '/settings/demo-settings',
  render: function render() {
    return /*#__PURE__*/_react["default"].createElement(DemoSettingsContainer, null);
  }
}];